import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import UseIcon from '@/components/UseIcon';
import PopupModal from '@/components/PopupModal';
import { createMetaManager } from 'vue-meta';
import './index.css';

export const APP_ID = 'ohg-alnylam-case-study-infographic';

const app = createApp(App);
const metaManager = createMetaManager();

app.use(router);
app.use(metaManager);

app.component('UseIcon', UseIcon);
app.component('PopupModal', PopupModal);
app.mount(`#${APP_ID}`);
